// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".snackbar__actions[data-v-427c1e32] {\n  gap: 16px;\n}", "",{"version":3,"sources":["webpack://./resources/js/System/Compenents/Snackbar/Snackbar.vue"],"names":[],"mappings":"AACI;EACI,SAAA;AAAR","sourcesContent":["\n    .snackbar__actions {\n        gap: 16px;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
